import { render, staticRenderFns } from "./MakuangMedicalLabelRecord.vue?vue&type=template&id=828038ec&scoped=true&"
import script from "./MakuangMedicalLabelRecord.vue?vue&type=script&lang=js&"
export * from "./MakuangMedicalLabelRecord.vue?vue&type=script&lang=js&"
import style0 from "./MakuangMedicalLabelRecord.vue?vue&type=style&index=0&id=828038ec&lang=scss&scoped=true&"
import style1 from "./MakuangMedicalLabelRecord.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828038ec",
  null
  
)

export default component.exports